/* tslint:disable */
/* eslint-disable */
/**
 * Juhsis REST Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiCredentialRequest } from '../models';
// @ts-ignore
import type { ApiCredentialResponse } from '../models';
/**
 * APICredentialsApi - axios parameter creator
 * @export
 */
export const APICredentialsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete an API credential. Only accessible by admin users.
         * @summary Delete credential
         * @param {DeleteCredentialCredentialTypeEnum} credentialType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCredential: async (credentialType: DeleteCredentialCredentialTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credentialType' is not null or undefined
            assertParamExists('deleteCredential', 'credentialType', credentialType)
            const localVarPath = `/api/credentials/{credentialType}`
                .replace(`{${"credentialType"}}`, encodeURIComponent(String(credentialType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get metadata for a specific credential (value not exposed). Only accessible by admin users.
         * @summary Get credential metadata
         * @param {GetCredentialMetadataCredentialTypeEnum} credentialType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredentialMetadata: async (credentialType: GetCredentialMetadataCredentialTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credentialType' is not null or undefined
            assertParamExists('getCredentialMetadata', 'credentialType', credentialType)
            const localVarPath = `/api/credentials/{credentialType}`
                .replace(`{${"credentialType"}}`, encodeURIComponent(String(credentialType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of all stored credentials (values not exposed). Only accessible by admin users.
         * @summary List all credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCredentials: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or update an API credential. Only accessible by admin users.
         * @summary Upsert credential
         * @param {ApiCredentialRequest} apiCredentialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertCredential: async (apiCredentialRequest: ApiCredentialRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiCredentialRequest' is not null or undefined
            assertParamExists('upsertCredential', 'apiCredentialRequest', apiCredentialRequest)
            const localVarPath = `/api/credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiCredentialRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * APICredentialsApi - functional programming interface
 * @export
 */
export const APICredentialsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = APICredentialsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete an API credential. Only accessible by admin users.
         * @summary Delete credential
         * @param {DeleteCredentialCredentialTypeEnum} credentialType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCredential(credentialType: DeleteCredentialCredentialTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCredential(credentialType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APICredentialsApi.deleteCredential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get metadata for a specific credential (value not exposed). Only accessible by admin users.
         * @summary Get credential metadata
         * @param {GetCredentialMetadataCredentialTypeEnum} credentialType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCredentialMetadata(credentialType: GetCredentialMetadataCredentialTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiCredentialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCredentialMetadata(credentialType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APICredentialsApi.getCredentialMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of all stored credentials (values not exposed). Only accessible by admin users.
         * @summary List all credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCredentials(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiCredentialResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCredentials(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APICredentialsApi.listCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create or update an API credential. Only accessible by admin users.
         * @summary Upsert credential
         * @param {ApiCredentialRequest} apiCredentialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertCredential(apiCredentialRequest: ApiCredentialRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertCredential(apiCredentialRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['APICredentialsApi.upsertCredential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * APICredentialsApi - factory interface
 * @export
 */
export const APICredentialsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = APICredentialsApiFp(configuration)
    return {
        /**
         * Delete an API credential. Only accessible by admin users.
         * @summary Delete credential
         * @param {DeleteCredentialCredentialTypeEnum} credentialType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCredential(credentialType: DeleteCredentialCredentialTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.deleteCredential(credentialType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get metadata for a specific credential (value not exposed). Only accessible by admin users.
         * @summary Get credential metadata
         * @param {GetCredentialMetadataCredentialTypeEnum} credentialType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredentialMetadata(credentialType: GetCredentialMetadataCredentialTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<ApiCredentialResponse> {
            return localVarFp.getCredentialMetadata(credentialType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of all stored credentials (values not exposed). Only accessible by admin users.
         * @summary List all credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCredentials(options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiCredentialResponse>> {
            return localVarFp.listCredentials(options).then((request) => request(axios, basePath));
        },
        /**
         * Create or update an API credential. Only accessible by admin users.
         * @summary Upsert credential
         * @param {ApiCredentialRequest} apiCredentialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertCredential(apiCredentialRequest: ApiCredentialRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.upsertCredential(apiCredentialRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * APICredentialsApi - object-oriented interface
 * @export
 * @class APICredentialsApi
 * @extends {BaseAPI}
 */
export class APICredentialsApi extends BaseAPI {
    /**
     * Delete an API credential. Only accessible by admin users.
     * @summary Delete credential
     * @param {DeleteCredentialCredentialTypeEnum} credentialType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APICredentialsApi
     */
    public deleteCredential(credentialType: DeleteCredentialCredentialTypeEnum, options?: RawAxiosRequestConfig) {
        return APICredentialsApiFp(this.configuration).deleteCredential(credentialType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get metadata for a specific credential (value not exposed). Only accessible by admin users.
     * @summary Get credential metadata
     * @param {GetCredentialMetadataCredentialTypeEnum} credentialType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APICredentialsApi
     */
    public getCredentialMetadata(credentialType: GetCredentialMetadataCredentialTypeEnum, options?: RawAxiosRequestConfig) {
        return APICredentialsApiFp(this.configuration).getCredentialMetadata(credentialType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of all stored credentials (values not exposed). Only accessible by admin users.
     * @summary List all credentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APICredentialsApi
     */
    public listCredentials(options?: RawAxiosRequestConfig) {
        return APICredentialsApiFp(this.configuration).listCredentials(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or update an API credential. Only accessible by admin users.
     * @summary Upsert credential
     * @param {ApiCredentialRequest} apiCredentialRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APICredentialsApi
     */
    public upsertCredential(apiCredentialRequest: ApiCredentialRequest, options?: RawAxiosRequestConfig) {
        return APICredentialsApiFp(this.configuration).upsertCredential(apiCredentialRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const DeleteCredentialCredentialTypeEnum = {
    SeekingAlphaPro: 'SEEKING_ALPHA_PRO',
    SeekingAlphaPremium: 'SEEKING_ALPHA_PREMIUM',
    Trading212ApiKey: 'TRADING212_API_KEY',
    Trading212ApiSecret: 'TRADING212_API_SECRET',
    InaTrading212ApiKey: 'INA_TRADING212_API_KEY',
    InaTrading212ApiSecret: 'INA_TRADING212_API_SECRET',
    Trading212Isa: 'TRADING212_ISA',
    Trading212Cfd: 'TRADING212_CFD',
    AlphaWorkerApiKey: 'ALPHA_WORKER_API_KEY',
    PolygonApiKey: 'POLYGON_API_KEY'
} as const;
export type DeleteCredentialCredentialTypeEnum = typeof DeleteCredentialCredentialTypeEnum[keyof typeof DeleteCredentialCredentialTypeEnum];
/**
 * @export
 */
export const GetCredentialMetadataCredentialTypeEnum = {
    SeekingAlphaPro: 'SEEKING_ALPHA_PRO',
    SeekingAlphaPremium: 'SEEKING_ALPHA_PREMIUM',
    Trading212ApiKey: 'TRADING212_API_KEY',
    Trading212ApiSecret: 'TRADING212_API_SECRET',
    InaTrading212ApiKey: 'INA_TRADING212_API_KEY',
    InaTrading212ApiSecret: 'INA_TRADING212_API_SECRET',
    Trading212Isa: 'TRADING212_ISA',
    Trading212Cfd: 'TRADING212_CFD',
    AlphaWorkerApiKey: 'ALPHA_WORKER_API_KEY',
    PolygonApiKey: 'POLYGON_API_KEY'
} as const;
export type GetCredentialMetadataCredentialTypeEnum = typeof GetCredentialMetadataCredentialTypeEnum[keyof typeof GetCredentialMetadataCredentialTypeEnum];
